module.exports = __webpack_public_path__ + "img/profess1.a88bfac6.png";